import React, { useEffect, useState } from 'react';

import Input from '../../../../Components/Input/Input';
import Select from '../../../../Components/Select/Select';
import Check from '../../../../Components/Check/Check';
import Button from '../../../../Components/Button/Button';
import SmallCard from '../../../../Components/SmallCard/SmallCard';
import FileInput from '../../../../Components/FileInput/FileInput';
import Modal from '../../../../Components/Modal/Modal';
import { mimeTypes } from '../../../../constants/constants';
import { useUlService } from '../../../../Services/UlSubjectService';
import { useFlService } from '../../../../Services/FlSubjectService';

import pdf from '../../../../icons/PdfIcon.svg';
import styles from './homes.modal.module.css';

export default function HomesModal({selectedApartment,isOpen, setIsOpen, subject,  }) {
  const [isSharer, setIsSharer] = useState(false);
  const [certificate, setСertificate] = useState(false);
  const [document, setDocument] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [flSubjects, setFlSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [email, setEmail] = useState('');
  const [inspection, setInspection] = useState(null);

  const dates = [{
    date: '23-02-2024 13:00',
    id: 1
  },{
    date: '23-02-2024 15:00',
    id: 2
  },{
    date: '23-02-2024 17:00',
    id: 3
  },{
    date: '24-02-2024 13:00',
    id: 4
  },{
    date: '24-02-2024 15:00',
    id: 5
  }]

  const { getUlSubjects } = useUlService();
  const { getFlSubjects } = useFlService();

  useEffect(() => {
    getUlSubjects().then(res => setSubjects(res))
    getFlSubjects().then(res => setFlSubjects(res.Data))
  }, [])

  useEffect(() => {
    setEmail(selectedSubject[0]?.Email)
  }, [selectedSubject])

  return (
    <Modal
      title={selectedApartment}
      isOpen={isOpen}
      setOpen={setIsOpen}
      onSave={() => console.log()}
      button={document?.name && <Button onClick={() => console.log(123)} text='Cоздать заявку на регистрацию права'/>}
    >
      <Input label='Кадастровый номер' placeholder='Введите кадастровый номер'/>
      <Select label='Вид объекта' placeholder='Выберите вид объекта'>
        <option value={1}>Жилое помещение</option>
        <option value={2}>Нежилое помещение</option>
        <option value={3}>Машиноместо</option>
      </Select>
      <Input label='Адрес' placeholder='Например, Почтовая ул., д. 9'/>
      <Input label='Площадь помещения' placeholder='80 м2'/>
      <Input label='Застройщик' disabled value={subjects?.filter(item => item.Id == subject)[0]?.Name}/>
      <Input label='Описание' isTextarea />
      <div>
        <Check label='У помещения есть ДДУ' onClick={() => setIsSharer(!isSharer)}/>
        {isSharer ?
          <div className={styles.sharer}>
            <label>Участник долевого строительства</label>
            <Select placeholder='Выберите участника долевого строительства' onChange={(e) => setSelectedSubject(flSubjects.filter((x) => x.Id === Number(e)))}>
              {flSubjects.map((subject) => {
                return (
                  <option value={subject.Id}>{`${subject.Lastname} ${subject.Firstname} ${subject.Middlename}`}</option>
                )
              })}
            </Select>
            <div className={styles.wrapper_email}>
              <label>Введите e-mail участника долевого строительства для отправки уведомления об окончании строительства</label>
              <div className={styles.email}>
                <Input onChange={(e) => setEmail(e)} value={email} placeholder='Введите E-mail участника'/>
                <Button isDisabled text='Отправить'/>
              </div>
            </div>
            <div>
              <label>Запись на приемку</label>
              {inspection ?
                <p>
                  {inspection[0].date} <label>Не прочитано</label>
                </p>
                :
                <Select onChange={(e) => setInspection(dates.filter((x) => x.id == e) )} placeholder='Дата и время записи на приемку'>
                  {dates.map((item) => {
                    return (
                      <option value={item.id}>{ item.date }</option>
                    )
                  })}
                </Select>
              }
              <div className={styles.manager}>
                <label>Менеджер по приемке: <b>Тест Николай Петрович</b> (тел: <a href="tel:+89001231231">+89001231231</a>)</label>
              </div>
            </div>
            <Check label='Принято без замечаний' onClick={() => setСertificate(!certificate)}/>
            {certificate &&
              <div className={styles.documents}>
                <label className={styles.label}>Загрузите подписанный сторонами и отсканированный акт приема-передачи</label>
                {document?.name ?
                  <SmallCard
                    avatar={pdf}
                    title={document.name}
                    onRemove={() => setDocument(null)}
                  />
                  :
                  <FileInput accept={[mimeTypes.Pdf]} onChange={(e) => setDocument(e)}/>
                }
              </div>
            }
          </div>
          :
          <div>
            <div className={styles.documents}>
              <label className={styles.label}>Разрешение на ввод  в эксплуатацию</label>
              {document?.name ?
                <SmallCard
                  avatar={pdf}
                  title={document.name}
                  onRemove={() => setDocument(null)}
                />
                :
                <FileInput accept={[mimeTypes.Pdf]} onChange={(e) => setDocument(e)}/>
              }
            </div>
          </div>
        }
      </div>
    </Modal>
  )
}
